module.exports = __webpack_public_path__ + "static/media/logo104.77948e34.png";